export const environment = {
  production: false,
  version: '1.0.0',
  emulator: false,
  env: 'dev',
  firebase: {
    apiKey: 'AIzaSyC5dUSUi5AK-Pobw3oTbNOler7QVMCOC24',
    authDomain: 'app-tienda-casa.firebaseapp.com',
    projectId: 'app-tienda-casa',
    storageBucket: 'app-tienda-casa.firebasestorage.app',
    messagingSenderId: '986074512555',
    appId: '1:986074512555:web:7643090d272b0ada2f8bee',
  },
};
